import { render } from "./overall-summary.vue?vue&type=template&id=7b3d2622&ts=true"
import script from "./overall-summary.vue?vue&type=script&lang=ts"
export * from "./overall-summary.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__